(() => {
  const showPassword = document.querySelector(".show-password-register");
  const hidePasswordIcon = document.querySelector(".hidepassword-icon");
  const showPasswordIcon = document.querySelector(".showpassword-icon");

  if (!showPassword) return;

  showPassword.addEventListener("click", function () {
    const password = document.querySelector('input[name="customer[password]"]');
    if (!password) return;

    if (password.type === "password") {
      password.type = "text";
      showPasswordIcon?.classList.add("js-hide");
      hidePasswordIcon?.classList.remove("js-hide");
    } else {
      password.type = "password";
      showPasswordIcon?.classList.remove("js-hide");
      hidePasswordIcon?.classList.add("js-hide");
    }
  });
})();
